import React, { useState } from 'react';
import Actions from '../../../actions/actions';
import PageSpinner from '../../shared/page_spinner';
import CustomerHelper from '../../../helpers/customer_helper';
import { TextField } from '@mui/material';

export default function EmailLink(props) {
  const [cemail, setEmail] = useState('');
  const [cfirstname, setFirstname] = useState('');
  const [clastname, setLastName] = useState('');

  const [spin, setSpin] = useState(false);

  const emailLink = async () => {
    setSpin(true);
    await Actions.getIndividualMarketingUrl({
      cfirstname,
      clastname,
      cemail,
    });
    setSpin(false);
    if (props && typeof props.close === 'function') {
      props.close();
    }
    Actions.setMessages([`QuickCheck email sent to: ${cemail}`]);
  };

  let isReady = CustomerHelper.validateEmail(cemail) && cfirstname && clastname;

  return (
    <div className="email-link-container">
      <TextField
        className="qa-qc-email-link-firstname text-field"
        fullWidth={true}
        required={true}
        size="small"
        margin="dense"
        variant="outlined"
        label="First Name"
        onChange={({ target: { value } }) => setFirstname(value)}
      />

      <TextField
        className="qa-qc-email-link-lastname text-field"
        fullWidth={true}
        required={true}
        size="small"
        margin="dense"
        variant="outlined"
        label="Last Name"
        onChange={({ target: { value } }) => setLastName(value)}
      />

      <TextField
        className="qa-qc-email-link-email text-field"
        fullWidth={true}
        size="small"
        margin="dense"
        variant="outlined"
        label="Email"
        required={true}
        onChange={({ target: { value } }) => setEmail(value)}
      />
      {!spin && (
        <button
          type="button"
          className="qa-qc-email-link-button action-primary action-alt"
          onClick={emailLink}
          disabled={!isReady}
        >
          <div>Send Pre-qualification Email</div>
        </button>
      )}
      {spin && <PageSpinner></PageSpinner>}
    </div>
  );
}
